import React from "react";
import { RefreshCw } from "lucide-react";
import { useAppVersion } from "../../hooks/useAppVersion.js";

export default function AppUpdateBanner() {
  const { updateAvailable, reload } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[99990] px-4 pb-4 pointer-events-none"
      role="status"
      aria-live="polite"
    >
      <div className="pointer-events-auto mx-auto flex w-full max-w-3xl items-center justify-between gap-3 rounded-xl border border-sky-200 bg-white px-4 py-3 shadow-lg">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900">Update available</p>
          <p className="text-xs text-slate-600">
            A new version of Dynesourcer is ready. Refresh to get the latest changes.
          </p>
        </div>
        <button
          type="button"
          onClick={reload}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-sky-600 px-3 py-2 text-sm font-semibold text-white hover:bg-sky-700"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </button>
      </div>
    </div>
  );
}
